/**
 * Industry design-system primitives (v3, 31.08.2026).
 *
 * <Blueprint> — the system's hairline frame: 1px border with four "+"
 * registration marks overhanging the corners. Every card, plate, figure
 * frame and the intake form is one of these; it has no surface fill.
 * CSS lives in globals.css (.blueprint / .corner).
 *
 * <Kicker> — the numbered section kicker («02 · Credit categories») with
 * its caption rule, per the section grammar.
 */
import type { CSSProperties, ReactNode } from 'react';

export function Blueprint({
  children,
  style,
  className,
  id,
}: {
  children: ReactNode;
  style?: CSSProperties;
  className?: string;
  /** Anchor id, for a frame that a link or a redirect lands on. */
  id?: string;
}) {
  return (
    <div id={id} className={className ? `blueprint ${className}` : 'blueprint'} style={style}>
      <i className="corner tl" />
      <i className="corner tr" />
      <i className="corner bl" />
      <i className="corner br" />
      {children}
    </div>
  );
}

export function Kicker({
  children,
  ruleMargin = '0 0 24px',
}: {
  children: ReactNode;
  ruleMargin?: string;
}) {
  return (
    <>
      <span className="ind-kicker">{children}</span>
      <hr className="ind-rule" style={{ margin: ruleMargin }} />
    </>
  );
}
